const appendUtmSource = url => `${url}${url.includes('?') ? '&' : '?'}utm_source=${process.env.REACT_APP_UTM_SOURCE}`

export default appendUtmSource